// extracted by mini-css-extract-plugin
export default {"submitBtn":"IssueForm_submitBtn__tK2hI","similar":"IssueForm_similar__jGePO"};